// Generated by Melange


const partial_arg = new (Intl.NumberFormat)("en-US", {
      minimumIntegerDigits: 2,
      minimumFractionDigits: 1,
      signDisplay: "always"
    });

function format(param) {
  return partial_arg.format(param);
}

export {
  format,
}
/* partial_arg Not a pure module */
